import script from "./Publish.vue?vue&type=script&lang=ts&setup=true"
export * from "./Publish.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__